import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function getTimeToMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 0, 0);
  const diff = midnight.getTime() - now.getTime();
  const h = Math.floor(diff / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1_000);
  return { h, m, s };
}

function pad(n: number) { return String(n).padStart(2, '0'); }

export function UrgencyBanner() {
  const [time, setTime] = useState(getTimeToMidnight());

  useEffect(() => {
    const interval = setInterval(() => setTime(getTimeToMidnight()), 1_000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      background: 'linear-gradient(90deg, #1A0B2E 0%, #0A0416 50%, #1A0B2E 100%)',
      borderBottom: '1px solid rgba(212,175,55,0.2)',
      padding: '0.625rem 1.5rem',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '1.5rem', flexWrap: 'wrap', textAlign: 'center',
    }}>
      <span style={{
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic', fontSize: 'var(--text-15)',
        color: '#F4E4C1', letterSpacing: '-0.01em',
      }}>
        ✦ Plano Anual com 20% OFF:{' '}
        <span style={{ textDecoration: 'line-through', opacity: 0.5, color: 'rgba(200,220,235,0.6)' }}>R$ 199,90</span>
        {' '}<strong style={{ color: '#D4AF37' }}>R$ 159,90</strong>
      </span>

      <div style={{ display: 'flex', gap: '0.375rem', alignItems: 'center' }}>
        {[
          { v: pad(time.h), label: 'h' },
          { v: pad(time.m), label: 'm' },
          { v: pad(time.s), label: 's' },
        ].map(({ v, label }, i) => (
          <span key={label} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
            {i > 0 && <span style={{ color: 'rgba(212,175,55,0.5)', fontWeight: 700 }}>:</span>}
            <span style={{
              background: 'rgba(212,175,55,0.12)',
              border: '1px solid rgba(212,175,55,0.25)',
              borderRadius: '4px', padding: '0.2rem 0.5rem',
              fontFamily: 'var(--font-display)', fontWeight: 700,
              fontSize: 'var(--text-15)', color: '#F4E4C1', minWidth: '2rem',
              textAlign: 'center',
            }}>
              {v}<span style={{ fontSize: '10px', opacity: 0.65, marginLeft: '1px' }}>{label}</span>
            </span>
          </span>
        ))}
      </div>

      <Link to="/register?plan=annual" style={{
        background: 'linear-gradient(135deg, #D4AF37 0%, #F4E4C1 100%)',
        color: '#0A0416',
        fontFamily: 'var(--font-body)',
        fontWeight: 700, padding: '0.4rem 1.25rem',
        fontSize: 'var(--text-13)', whiteSpace: 'nowrap',
        borderRadius: 'var(--radius-pill)',
        textDecoration: 'none',
        display: 'inline-block',
      }}>
        Aproveitar desconto
      </Link>
    </div>
  );
}
